import React from "react";
import { Stack, Typography, Card } from "investira.react.components";
import { formats } from "investira.sdk";
const Highlights = props => {
  const {
    data
  } = props;
  const xCenarios = data?.response?.resumo?.impacto?.cenarios;
  const xImpactosOrdenados = Array.isArray(xCenarios) ? xCenarios.sort((a, b) => b.impacto_financeiro - a.impacto_financeiro) : [];
  const xMaiorImpactoPos = xImpactosOrdenados[0];
  const xMaiorImpactoNeg = xImpactosOrdenados[xImpactosOrdenados.length - 1];
  return <>
      <Stack direction="column" sx={{
      gap: 1
    }} component="section" flexGrow={1}>
        <Stack gap={1} flexGrow={0} direction={{
        xs: "column",
        md: "row"
      }}>
          <Card sx={{
          flexGrow: 1,
          display: "flex",
          minHeight: 0
        }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{
              fontWeight: 500
            }}>
                Total Financeiro
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(data.response?.resumo.financeiro || 0, 2, true, true)}
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>

          <Card sx={{
          flex: 1,
          display: "flex",
          minHeight: 0
        }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{
              fontWeight: 500
            }}>
                Amostragem
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{data.request.dias}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>

          <Card sx={{
          flex: 1,
          display: "flex"
        }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{
              fontWeight: 500
            }}>
                Ativos Analisados
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {data.response?.resumo.estatisticas.quantidade_ativos_analisados}
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>

        <Stack gap={1} flexGrow={0} direction={{
        xs: "column",
        md: "row"
      }}>
          <Card sx={{
          flexGrow: 1,
          display: "flex",
          minHeight: 0
        }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{
              fontWeight: 500
            }}>
                Maior Impacto Positivo
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(xMaiorImpactoPos?.impacto_financeiro || 0, 2, true, true)}
                    </b>
                  </Typography>
                  <Typography variant="caption" color="textPrimary">
                    {xMaiorImpactoPos?.cenario}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>

          <Card sx={{
          flexGrow: 1,
          display: "flex",
          minHeight: 0
        }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography variant="caption" color="textPrimary" sx={{
              fontWeight: 500
            }}>
                Maior Impacto Negativo
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {formats.formatNumber(xMaiorImpactoNeg?.impacto_financeiro < 0 ? xMaiorImpactoNeg?.impacto_financeiro : 0, 2, true, true)}
                    </b>
                  </Typography>
                  <Typography variant="caption" color="textPrimary">
                    {xMaiorImpactoNeg?.impacto_financeiro < 0 ? xMaiorImpactoNeg?.cenario : "---"}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>

          {/* <FundosAbertos data={data} /> */}
          {/* <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Fundos Abertos
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>
                      {
                        data.response?.resumo.estatisticas
                          .quantidade_fundos_abertos
                      }
                    </b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
           </Card> */}
        </Stack>
      </Stack>
    </>;
};
export default Highlights;
